'use client';

import { PostPurchase } from '@depop/web-thrift-ui/Illustrations/PostPurchase';
import { clsx } from 'clsx';
import { useTranslations } from 'next-intl';

import { useFreeShippingMessagingExperiment } from '../useFreeShippingMessagingExperiment';

import styles from './styles.module.css';

import { CalloutBanner } from '@/components/CalloutBanner';
import { SupportedLocation } from '@/modules/location/constants';
import { useCurrentLocation } from '@/modules/location/useCurrentLocation';
import { useCountryHeader } from '@/modules/user/useCountryHeader';

type Props = {
  variant: 'loggedIn' | 'loggedOut';
};

export function ShippingCalloutBanner({ variant }: Props) {
  const t = useTranslations('common');
  const countryCode = useCountryHeader();
  const { location } = useCurrentLocation();

  const isUSA = countryCode?.toUpperCase() === 'US';
  // USA banner yields to the AU no selling fees banner when the site is set to Australia
  const inVariant = useFreeShippingMessagingExperiment(
    isUSA && location !== SupportedLocation.AU
  );

  if (!inVariant) {
    return null;
  }

  const isLoggedOut = variant === 'loggedOut';

  return (
    <CalloutBanner
      className={clsx({
        [styles['shippingCalloutBanner--additionalMargin']]: isLoggedOut,
      })}
      illustration={
        <PostPurchase
          size="xSmall"
          alt={t('USFreeShippingBanner.IllustrationAlt')}
        />
      }
      title={t('USFreeShippingBanner.Title')}
      body={t(
        isLoggedOut
          ? 'USFreeShippingBanner.HomepageBodyLoggedOut'
          : 'USFreeShippingBanner.HomepageBodyLoggedIn'
      )}
      cta={
        isLoggedOut
          ? { label: t('USFreeShippingBanner.SignupCta'), href: '/signup' }
          : undefined
      }
    />
  );
}
